// extracted by mini-css-extract-plugin
export default {"subList":"CarsCategoryLinks-subList","Tabs":"CarsCategoryLinks-Tabs","AllBrandsList":"CarsCategoryLinks-AllBrandsList"};